@if (isComponentLoading()) {
  <sd-skeleton
    [appearance]="SkeletonAppearanceEnum.media"
    [ratio]="imgRatio() ?? ImageRatioEnum.r4_3"
    [sizeChangeMobile]="false"
    [count]="1"
  />
} @else {
  <ng-container *ngTemplateOutlet="mediaTemplate; context: {
    isModal: false,
    hasModal: hasModal(),
    imageRatio: imgRatio()
  }" />
  <!-- Modal -->
  @if (isVideo() && hasModal()) {
    <sd-modal-default
      (isOpenedChange)="toggleModal($event)"
      [hasHeader]="false"
      [titleHidden]="true"
      [modalTitleLevel]="4"
      [(isOpened)]="isOpen"
      [modalTitle]="media().altText"
      [modalCustomClass]="(controlsVideo() || isYoutube()) ? 'has-control c__banner-modal' : 'c__banner-modal'"
    >
      <ng-container *ngTemplateOutlet="mediaTemplate; context: {
        isModal: true,
        hasModal: true
      }" />
    </sd-modal-default>
  }
}

<ng-template #mediaTemplate let-isModal="isModal" let-hasModal="hasModal" let-ratio="imageRatio">
  @let canModal = hasModal && !isModal;
  @let isPlaying = play();

  <div class="c__banner-wrapper {{hasBorder() ? 'has-border' : '' }} {{isPlaying ? '' : 'is-paused'}}">
    @if (!isVideoThumbnail() && (isVideo() || isGif())) {
      <div class="c__control-container {{canModal ? 'is-full-area' : ''}}" (click)="toggleAction(isModal)">
        @if (showPlayButton()) {
          <button sd-button
            class="c__play-pause is-circular {{'is-' + buttonPosition()}} {{canModal || isGif() ? 'is-fixed' : ''}}"
            type="button"
            [isIcon]="true"
            [isPlayer]="true"
            [theme]="ThemeEnum.light"
            [isSmall]="isButtonSmall() || !isVideo()"
            [icon]="isPlaying ? 'icon-pause' : 'icon-play'"
            [attr.data-id-video]="customId()"
          >
            <span class="is-visually-hidden">
              {{ (isPlaying ? 'actions.stop' : 'actions.start') | translate }}
              @if (title(); as t) {
                - {{t}}
              }
            </span>
          </button>
        }
      </div>
    }

    @if (isVideoThumbnail()) {
      <sd-icon name="icon-play" />
    }

    @if (isVideo()) {
      <!-- Manage video -->
      <sd-media video
        #mediaVideo
        [videoTitle]="videoTitle()"
        [customId]="customId()"
        [(play)]="play"
        (mediaEnded)="onMediaEnded()"
        [autoplayVideo]="autoplayVideo()"
        [loopVideo]="loopVideo()"
        [muted]="muted()"
        [isYoutube]="isYoutube()"
        [imgRatio]="ratio"
        [controlsVideo]="controlsVideo()"
        [hasModal]="hasModal"
        [isModal]="isModal"
        [media]="media()"
      />
    } @else {
      <!-- Manage Images / Gif -->
      <sd-media image
        #mediaImage
        (imageIsLoaded)="imageLoaded()"
        [twicPicsAutoSize]="twicPicsAutoSize()"
        [(play)]="play"
        [width]="width()"
        [height]="height()"
        [isGif]="isGif()"
        [isFit]="isFit()"
        [imgRatio]="ratio"
        [media]="media()"
        [isZoomed]="!isGif() && isZoomed()"
        [zoomLevel]="zoomLevel()"
      />
    }
  </div>
</ng-template>
